import {
  GET_VIDEO_CONTENT,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialVideoContent = {
  eh_videoContent: [],
  videoContentCount: 0,
  page: 1,
  search: "",
  courseId: "",
  sortby: "",
  orderby: "desc",
};

const videoContentReducer = (state = initialVideoContent, action) => {
  switch (action.type) {
    case GET_VIDEO_CONTENT:
      return {
        ...state,
        eh_videoContent: action.payload.videoContent,
        videoContentCount: action.payload.totalCount,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default videoContentReducer;
